import React, { useState } from 'react';

const Login = ({ onLogin, currentSectionId }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const res = await fetch('/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    username,
                    password,
                    sectionId: currentSectionId // Ուղարկում ենք, որ սերվերը ստուգի հենց այս էջի թույլտվությունը
                })
            });

            const data = await res.json();

            if (res.ok) {
                // Backend-ը վերադարձնում է օրինակ՝ { role: 'admin', access: 'web', redirect: '...' }
                onLogin(data);
            } else {
                setError(data.error || "Մուտքը մերժված է");
            }
        } catch (err) {
            setError("Սերվերի սխալ");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-form">
            <h2>Մուտք</h2>
            {error && <p className="error-text" style={{ color: 'red' }}>{error}</p>}
            <form onSubmit={handleSubmit}>
                <input
                    type="text"
                    placeholder="Օգտանուն"
                    onChange={e => setUsername(e.target.value)}
                    required
                />
                <input
                    type="password"
                    placeholder="Գաղտնաբառ"
                    onChange={e => setPassword(e.target.value)}
                    required
                />
                <button type="submit" disabled={loading}>
                    {loading ? "Ստուգվում է..." : "Ուղարկել"}
                </button>
            </form>
        </div>
    );
};

export default Login;